import ViewList from './view/view_list.vue'
import Search from './module/search.vue'
import SearchItem from './module/search_item.vue'
import ProductInfo from './module/product_info.vue'
import Operate from './module/operate.vue'
import CustomForm from './module/custom_form.vue'
import CustomTable from './module/custom_table.vue'
import State from './public/state.vue'
import Tags from './public/tags.vue'
import ProcessRate from './public/process_rate.vue'
import InfoCard from './public/info_card.vue'
import SelectOption from './public/select_option.vue'

import UploadFile from './extend/upload_file.vue'
import File from './extend/file.vue'

var comps = [
	ViewList,
	Search,
	SearchItem,
	ProductInfo,
	Operate,
	CustomForm,
	CustomTable,
	State,
	Tags,
	ProcessRate,
	InfoCard,
	SelectOption,

	UploadFile,
	File
]

// 导出组件
export default {
	install: function(Vue) {
		comps.forEach(comp => {
			Vue.component(comp.name, comp);
		})
    }
}